import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { InstallationAniloxPluginService } from './anilox.service';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ConfirmComponent } from '../../../modal/confirm.component';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'lodash';
import { BaseInstallationEditPageComponent } from '../base-installation/edit-view.component';
import { Subscription } from 'rxjs';

@Component({
    selector: 'installation-anilox-edit',
    templateUrl: './anilox-edit.component.html',
    standalone: false
})
export class InstallationAniloxEditPageComponent
  extends BaseInstallationEditPageComponent
  implements OnInit, OnDestroy
{
  plugin: any;
  editForm: UntypedFormGroup;
  anilox: any[];

  private aniloxToRemove: number;
  private sub = new Subscription();

  @ViewChild('aniloxDeleteConfirm', { static: true }) aniloxDeleteConfirm: ConfirmComponent;

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected router: Router,
    location: Location,
    protected cdRef: ChangeDetectorRef,
    protected pluginService: InstallationAniloxPluginService,
    private fb: UntypedFormBuilder
  ) {
    super(location, pluginService, activatedRoute, router);
  }

  get formData() {
    return <UntypedFormArray>this.editForm.controls['anilox'];
  }

  ngOnInit(): void {
    this.sub.add(
      this.initRoute().subscribe(() => {
        this.initData();
      })
    );
  }

  public save(model: any) {
    this.processing = true;
    this.pluginService.updateAnilox(this.inspectionId, this.pointId, this.pluginId, model.anilox).subscribe((res) => {
      this.processing = false;
      this.goToBack();
    });
  }

  public add() {
    const control = <UntypedFormArray>this.editForm.controls['anilox'];
    control.push(this.initAnilox());
  }

  public openAniloxDeleteConfirm(i: number) {
    this.aniloxDeleteConfirm.open();
    this.aniloxToRemove = i;
  }

  public remove(e: any) {
    const control = <UntypedFormArray>this.editForm.controls['anilox'];
    control.removeAt(this.aniloxToRemove);
  }

  public checkIfPositive(event) {
    if (event.target.value < 0) event.target.value = 0;
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  private initData() {
    this.service.getPlugin(this.inspectionId, this.pluginId).subscribe((data) => {
      this.plugin = data;
      this.initForm();
      this.cdRef.detectChanges();
    });
  }

  private initForm() {
    this.editForm = this.fb.group({
      anilox: this.fb.array([])
    });

    const control = <UntypedFormArray>this.editForm.controls['anilox'];
    _.forEach(this.plugin.config.Anilox, (el) => {
      control.push(this.initAnilox(el));
    });
  }

  private initAnilox(el?: any) {
    return this.fb.group({
      aniloxNumber: new UntypedFormControl(el && el.AniloxNumber ? el.AniloxNumber : ''),
      supplier: new UntypedFormControl(el && el.Supplier ? el.Supplier : ''),
      volume: new UntypedFormControl(el && el.Volume ? el.Volume : ''),
      angle: new UntypedFormControl(el && el.Angle ? parseInt(el.Angle) : ''),
      screen: new UntypedFormControl(el && el.Screen ? parseInt(el.Screen) : ''),
      deliveredPrior: new UntypedFormControl(el && el.DeliveredPrior !== null ? el.DeliveredPrior : null)
    });
  }
}
